import { FortinetSvg } from 'common/svg/FortinetSvg';
import { StyledLoadingSpinner } from './LoadingSpinner.styles';
import { SpinnerAnimationStyles } from './LoadingSpinner.styles';

export const LoadingSpinner = ({
  fill,
  size = 50,
}: {
  fill?: string;
  size?: number;
}) => (
  <StyledLoadingSpinner>
    <SpinnerAnimationStyles />
    <FortinetSvg fill={fill} height={size} width={size} />
  </StyledLoadingSpinner>
);
